import { Component } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import { withLargeButtonAlignment } from '@skyscanner/backpack-web/bpk-component-icon';
import ArrowUpIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/long-arrow-up';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { FormattedMessage } from '../i18n';

import STYLES from './ScrollTopButton.module.scss';

import { getScrollY } from '@shared/utils-frontend/window';

type Props = {
  showMinHeight?: number;
  className?: string;
};

type State = {
  show: boolean;
};

const defaultProps = {
  showMinHeight: 60,
  className: null,
};

const cls = cssModules(STYLES);
const AlignedArrowUpIcon = withLargeButtonAlignment(ArrowUpIcon);

class ScrollTopButton extends Component<Props, State> {
  static defaultProps = defaultProps;

  state: State = {
    show: false,
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const { showMinHeight } = this.props;
    const scrollY = getScrollY();
    if (scrollY > showMinHeight! && !this.state.show) {
      this.setState({ show: true });
    } else if (scrollY < showMinHeight! && this.state.show) {
      this.setState({ show: false });
    }
  };

  render() {
    return (
      this.state.show && (
        <BpkButtonV2
          size={SIZE_TYPES.large}
          type={BUTTON_TYPES.secondary}
          className={cls('ScrollTopButton', this.props.className)}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }}
        >
          <AlignedArrowUpIcon />
          <span>
            <FormattedMessage label="ScrollToTop_label_title" />
          </span>
        </BpkButtonV2>
      )
    );
  }
}

export default ScrollTopButton;
